import React, { useEffect } from "react"
import Header from "./Header"
import Sidebar from "./Sidebar"
import useAdminMe from "../../hooks/useAdminMe"
import AdminPermissionGate from "../AdminPermission/AdminPermissionGate"

const AdminLayout = ({ children }) => {
  useAdminMe()

  useEffect(() => {
    document.body.classList.add("admin-layout-active")
    document.body.classList.remove(
      "sidebar-enable",
      "vertical-collpsed",
    )
    document.body.removeAttribute("data-sidebar-size")
    document.body.removeAttribute("data-layout")
    document.body.removeAttribute("data-topbar")
    document.body.removeAttribute("data-sidebar")

    return () => {
      document.body.classList.remove(
        "admin-layout-active",
        "admin-sidebar-collapsed",
        "admin-sidebar-open",
      )
    }
  }, [])

  return (
    <div className="admin-layout">
      <Sidebar />
      <div className="admin-layout__main">
        <Header />
        <main className="admin-layout__content">
          <AdminPermissionGate>{children}</AdminPermissionGate>
        </main>
      </div>
    </div>
  )
}

export default AdminLayout
